import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { cloneDeep } from 'lodash-es';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

const EditMember = lazy(
  () => import('../../../../main/agency/profile/users-sections/staff-roster/sections/edit-member/EditMember'),
);

const AgencyInvitationSections = lazy(
  () => import('../../../../main/agency/profile/users-sections/staff-roster/sections/AgencyInvitationSections'),
);

const MemberCertificate = lazy(
  () =>
    import('../../../../main/agency/profile/users-sections/staff-roster/sections/member-certificate-section/MemberCertificateSection'),
);

export const agencyInvitationRoutes: RouteObject[] = [
  {
    path: '',
    element: <AgencyInvitationSections />,
    children: [
      {
        path: '',
        element: <Navigate replace to="permissions" />,
      },
      {
        path: 'permissions',
        element: (
          <Suspense fallback={<DataLoader />}>
            <EditMember />
          </Suspense>
        ),
      },
      {
        path: 'certificate',
        element: (
          <Suspense fallback={<DataLoader />}>
            <MemberCertificate />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <Error404Page />,
      },
      {
        path: ':any/*',
        element: <Error404Page />,
      },
    ],
  },
];

export const getAgencyInvitationRoutes = (excludes: string[]): RouteObject[] => {
  const routes = cloneDeep(agencyInvitationRoutes);
  const result =
    routes[0].children?.filter((route: RouteObject) => {
      const path = route.path || '';
      return !excludes.some((exclude) => path.includes(exclude));
    }) ?? [];

  routes[0].children = result;
  return routes;
};
